<header [ngClass]="styles.header" layout="row" flex-justify="end">
	<ng-content select="[header]">
	</ng-content>
</header>
<ng-content select="[body]">
</ng-content>
